/*jshint esversion: 6 */
var token = Cookies.get("token");
var userCookie = Cookies.get("user");
if (!token) {
  window.location.href = "login.html";
}

$(function() {
  /**
   * Backend functions--------------------------------------------------
   **/
  window.getDataAjax = function(url) {
    return $.ajax({
      url: url,
      type: 'GET',
      cache: false,
      contentType: false,
      processData: false,
      xhrFields: {
        withCredentials: true
      },
      beforeSend: function(xhr) {
        xhr.setRequestHeader("Authorization", "Basic " + token);
        xhr.setRequestHeader("IEAuth", "Basic " + token);
      }
    });
  };
// getData for history tab
  window.getDataHistory = function() {
    var url = "/s2mis_ws/history_report?";
    getDataAjax(url)
      .done(function(result, textStatus, status) {
        if (status.status == 200) {
          makeTableHistory(result);
          //listen for refresh
          $("#updateHistory").on("click", function(e) {
            var $icon = $(this).find(".glyphicon.glyphicon-refresh"),
              animateClass = "glyphicon-refresh-animate";
            $icon.addClass(animateClass);
            getDataHistory();
          });
        } else {
          showError(result, "History");
        }
      })
      .fail(function(xhr, status, error) {
        showError(xhr, "History");
      });
  };
// getData for statestikk tab
  window.getDataStatistikk = function() {
    var url = "/s2mis_ws/statistikk?";
    getDataAjax(url)
      .done(function(result, textStatus, status) {
        if (status.status == 200) {
          makeTableStatistikk(result);
          $("#updateStatistikk").on("click", function(e) {
            var $icon = $(this).find(".glyphicon.glyphicon-refresh"),
              animateClass = "glyphicon-refresh-animate";
            $icon.addClass(animateClass);
            getDataStatistikk();
          });
        } else {
          showError(result, "Statistikk");
        }
      })
      .fail(function(xhr, status, error) {
        showError(xhr, "Statistikk");
      });
  };

  /**
   * Other common functions--------------------------------------------------
   **/
  window.showError = function(error, tabName = '') {
    if (error.status == 500) {
      $("#alertMsg" + tabName).text(
        "En feil har oppstått, ingen kontakt med serveren: " +
        error.status +
        ": " +
        error.statusText
      );
    } else if (error.status == 503) {
      $("#alertMsg" + tabName).text(
        "En feil har oppstått, ingen kontakt med serveren: " +
        error.status +
        ": " +
        error.statusText
      );
    } else if (error.status == 504) {
      $("#alertMsg" + tabName).text(
        "Serveren har brukt for lang tid, feilkode: " +
        error.status +
        ": " +
        error.statusText
      );
    } else if (error.status == 404) {
      $("#alertMsg" + tabName).text(
        "En feil har oppstått, ingen kontakt med servern, feilkode: " +
        error.status +
        ": " +
        error.statusText
      );
    } else {
      if (typeof error.responseText !== "undefined") {
        $("#alertMsg" + tabName).text(error.responseText);
      } else {
        $("#alertMsg" + tabName).text(error);
      }
    }
    $("#tableDiv").html("");
    $("#tableObjectReport").html("");
    $("#errorButtonDiv").html("");
    $("#sbaseSpinner").removeClass("spinner");
    $("#saveButton").prop("disabled", true);
    $("#controlButton").prop("disabled", true);
  };

  window.makeTableHistory = function(history_input) {
    var tableRow = "<thead><tr>";
    tableRow += "<th>Dato</th>";
    tableRow += "<th>BrukerID</th>";
    tableRow += "<th>PEFC</th>";
    tableRow += "<th>Hendelse</th>";
    tableRow += "<th>Resultat</th>";

    if (history_input) {
      var history = JSON.parse(history_input).history;
      var status = JSON.parse(history_input).ekstra_info;
      // not all object have ekstra info, go only on jobbid, we have info for data without jobbid,
      // maybe we should always show "Ekstra informasjon"
      if (status > 0) {
        tableRow += "<th>Ekstra informasjon</th>";
      }
      tableRow += "<th></tr></thead></th>";
      tableRow += "<tbody>";
      var i = 0;

      $.each(history, function(index, value) {
        tableRow += "<tr>";
        tableRow += "<td>" + value.dato + "</td>";
        tableRow += "<td>" + value.epost + "</td>";
        tableRow += "<td>" + value.firma + "</td>";

        // for now we have 3 states, Lagret, Kjørt kontroll ok, kjørt kontroll feilet
        if (value.hendelse === "lagring av data" && status > 0 && value.jobbid) {
          tableRow += "<td>" + value.hendelse + "</td>";
          tableRow += "<td>" + value.resultat + "</td>";
          tableRow +=
            '<td><a title="Rapport for lagring" data-toggle="modal" data-target="#commonModal" id=' +
            value.jobbid +
            ">";
          tableRow +=
            '<span class="glyphicon glyphicon-plus"></span></a></td></tr>';
        } else if (value.hendelse === "sjekk av data" && value.resultat === "feilet") {
          tableRow += "<td>" + value.hendelse + "</td>";
          tableRow += "<td>" + value.resultat + "</td>";
          tableRow +=
            '<td><a title="Rapport for sjekk av data, resultat feilet" data-toggle="modal" data-target="#commonModal" id=' +
            value.testtabellprefix +
            ">";
          tableRow +=
            '<span class="glyphicon glyphicon-plus"></span></a></td></tr>';
        } else if (value.hendelse === 'sjekk av data' && status > 0 && value.resultat === 'ok') {
          tableRow += '<td>' + value.hendelse + '</td>';
          tableRow += '<td>' + value.resultat + '</td>';
          tableRow +=
            '<td><a title="Rapport for sjekk av data, resultat ok" data-toggle="modal" data-target="#commonModal" id=' +
            value.jobbid +
            ">";
          tableRow +=
            '<span class="glyphicon glyphicon-plus"></span></a></td></tr>';

        } else {
          tableRow += "<td>" + value.hendelse + "</td>";
          tableRow += "<td>" + value.resultat + "</td></tr>";
        }
        i++;
      });
    }
    tableRow += "</tbody>";
    $("#tableHistory").html(tableRow);
    $("#refreshHistory").html(
      '<a id="updateHistory" title="Oppdater historikken" href="#"><i class="glyphicon glyphicon-refresh"></i></a>'
    );
    // need to tell sortable that DOM is ready
    $.bootstrapSortable(true);
  };

  window.makeTableStatistikk = function(statistikk_input) {
    var tableRow = "<thead><tr>";
    tableRow += "<th>Dato</th>";
    tableRow += "<th>JobbID</th>";
    tableRow += "<th>Prosjektnavn</th>";
    tableRow += "<th>Ansvarlig for opplastning</th>";
    tableRow += "<th>Antall objekter</th>";
    tableRow += "<th>Ekstra informasjon</th>";
    tableRow += "<th></tr></thead></th>";
    tableRow += "<tbody>";

      if (statistikk_input) {
        var statistikk = JSON.parse(statistikk_input);
        $.each(statistikk, function(index, value) {
          if (!value.navn) {value.navn = 'ikke oppgitt';}
          tableRow += "<tr>";
          tableRow += "<td>" + value.dato + "</td>";
          tableRow += "<td>" + value.jobbid + "</td>";
          tableRow += "<td>" + value.navn + "</td>";
          tableRow += "<td>" + value.brukernavn + "</td>";
          tableRow += "<td>" + value.antall + "</td>";
          tableRow +=
            '<td><a title="Lenker til Kilden og rapporter" data-toggle="modal" data-target="#commonModal" id=' +
            value.jobbid +
            ">";
          tableRow +=
            '<span class="glyphicon glyphicon-plus"></span></a></td></tr>';
        });
      }

    tableRow += "</tbody>";
    $("#tableStatistikk").html(tableRow);
    $("#refreshStatistikk").html(
      '<a id="updateStatistikk" title="Oppdater statistikken" href="#"><i class="glyphicon glyphicon-refresh"></i></a>'
    );
    // need to tell sortable that DOM is ready
    $.bootstrapSortable(true);
  };
});
